import { graphql } from "react-relay";
import { DataSources } from "@components/data-sources";
import { LunchGoal, WorkPreferenceGoal, TravelTimeGoal } from "@components/goals-wrapper";
import { SmartHoldSync } from "@components/smart-hold-sync";

export const query = graphql`
  query WebSettingsSmartHoldsRelayQuery {
    viewer {
      # ...SettingsDialog_viewer
      user {
        ...DataSources_user
        orgs(first: 1000000) {
          edges {
            node {
              id
              userGoals(first: 1000000) {
                edges {
                  node {
                    id
                    goalId
                    targetUrn {
                      id
                      type
                      value
                    }
                    otherUrns {
                      id
                      type
                      value
                    }
                    name
                    valueUrn {
                      id
                      type
                      value
                    }
                    isDeleted
                    options {
                      syncToGoogle
                      specificOptions {
                        ... on GoalWithinDayOptions {
                          minTimeSlot
                          maxTimeSlot
                          minimumDuration
                          idealDuration
                        }
                      }
                    }
                  }
                }
              }
              ...WorkPreferenceGoal_org
              ...SmartHoldSync_org
              ...LunchGoal_org
              ...TravelTimeGoal_org
              ...DataSources_org
            }
          }
        }
      }
    }
  }
`;
